import { useSessionState } from "./use-session-state"

export const useSessionKey = () => {
  return useSessionState((s) => s.sessionToken)
}

/**
 * Whether `token` is a usable Seam session token. Rejects the stringified
 * `"null"` / `"undefined"` too: interpolating a missing token into a header
 * yields exactly those, and seam-connect rejects them as a malformed JWT.
 */
export const isUsableSessionToken = (
  token: string | null | undefined
): token is string =>
  token != null && token !== "" && token !== "null" && token !== "undefined"

/** The current session token, or `null` when there isn't a usable one. */
export const getSessionToken = (): string | null => {
  const token = useSessionState.getState().sessionToken
  return isUsableSessionToken(token) ? token : null
}

/**
 * Whether the console has a usable Seam session. Gate session-authenticated
 * queries on this rather than `isAuthenticated` alone: the flag and the token
 * are set independently, and a query that runs without a token sends
 * `Authorization: Bearer null`.
 */
export const useHasSession = () => {
  return useSessionState(
    (s) => s.isAuthenticated && isUsableSessionToken(s.sessionToken)
  )
}
